import React, { useEffect } from 'react';
import SectionHeader from 'components/SectionHeader/SectionHeader';
import {
  MediaGalleryPageContextProvider,
  useMediaGalleryPageContext,
} from './media-gallery-page.context';
import MediaGalleryFilters from './Filter';
import Loading from 'components/Messages/Loading/Loading';
import MediaGallery, { MediaGalleryFileInterface } from 'components/MediaGallery/MediaGallery';
import ContentWrapper from 'components/StyledComponents/ContentWrapper';
import { formatDate } from 'utils/formatting';
import { groupBy, GroupByReturnType } from 'utils/array';

const MediaGalleryPageComponent = () => {
  const { media, loading, refetch } = useMediaGalleryPageContext();

  const mediaGalleryFiles: MediaGalleryFileInterface[] = media?.map((file, index) => ({
    id: file.id,
    url: file.signedUrl,
    caption: formatDate(file.createdAt),
    link: file.step.activity.id ? `/activities/${file.step.activity.id}` : undefined,
    index,
    fileType: file.fileType,
    store: file.step.activity.store?.name ?? '',
    mediaComments: file.comments,
  }));

  useEffect(() => {
    refetch();
  }, [media?.length]);

  // # TODO: group images by the store property
  // const groupedMedia = groupBy(mediaGalleryFiles, 'store');

  if (loading) {
    return <Loading />;
  }

  return (
    <>
      <SectionHeader pageHeader title='Gallery' />
      <ContentWrapper>
        {/* <MediaGalleryFilters /> */}
        {/* <MediaGallery groupedFiles={groupedMedia} /> */}
        <MediaGallery files={mediaGalleryFiles} />
      </ContentWrapper>
    </>
  );
};

const MediaGalleryPage = () => (
  <MediaGalleryPageContextProvider>
    <MediaGalleryPageComponent />
  </MediaGalleryPageContextProvider>
);

export default MediaGalleryPage;
